<template>
  <v-dialog
    v-model="dialogVisible"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card v-if="dialogVisible" outlined>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="text-h6">
          <v-icon left>mdi-file-document-multiple</v-icon>
          Búsqueda de Vouchers/Bonos
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="loadVouchers" :disabled="selectedVouchers.length == 0">
          <v-icon left>mdi-content-save</v-icon>
          Guardar ({{ selectedVouchers.length }})
        </v-btn>
        <v-btn icon @click="closeDialog" class="ml-2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4">
        <v-card outlined class="mb-4">
        
          <v-card-text class="pt-4">
            <v-row>
              <!-- Fecha efectiva -->
              <v-col cols="12" md="4">
                <div class="text-subtitle-2 mb-2">
                  <v-icon small color="primary" class="mr-1">mdi-calendar-range</v-icon>
                  Fecha efectiva
                </div>
                <GeneralGhCalendar
                  :show_second_list="false"
                  :automatic_selection="true"
                  :update_second_with_one="true"
                  @set_range="get_range"
                />
              </v-col>

              <!-- Moneda y Tipo -->
              <v-col cols="12" md="4" align="center" justify="center">
                <div class="text-subtitle-2 mb-2">
                  <v-icon small color="primary" class="mr-1">mdi-currency-usd</v-icon>
                  Moneda
                </div>
                <v-btn-toggle
                  v-model="selected_currency_id"
                  mandatory
                  color="primary"
                  class="d-flex justify-center mb-4"
                  :disabled="currencies == null || currencies.length === 0"
                >
                  <v-btn
                    v-for="(item, i) in currencies"
                    :key="i"
                    :value="item.id"
                    small
                  >
                    {{ item.code }}
                    <country-flag
                      :country="getFlag(item.id)"
                      size="small"
                      class="ml-n2"
                    />
                  </v-btn>
                </v-btn-toggle>
                <v-row align="center" justify="center" >
                  <v-col md="7">
                 <v-autocomplete
                  v-model="tipVoucher"
                  :items="voucherTypes"
                  label="Tipo de comprobante"
                  return-object
                  dense
                  outlined
                  hide-details="auto"
                  prepend-inner-icon="mdi-file-document"
                  :rules="[(v) => !!v || 'Tipo es requerido']"
                  required
                  @change="onTipVoucherChange"
                ></v-autocomplete>
                  </v-col>
                   <v-col md="4">
                      <v-btn v-if="manual_currency_rate==null"
                        outlined
                        dense @click="manual_currency_rate=0"
                        color="primary"
                        >Establecer tasa
                      </v-btn>
                        <v-text-field v-else
                         label="Tasa"
                         v-model="manual_currency_rate"
                         outlined type="number"
                         dense 
                         hide-details
                        >                         
                        </v-text-field>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Cliente y Sucursal -->
              <v-col cols="12" md="4">
                <div class="text-subtitle-2 mb-2">
                  <v-icon small color="primary" class="mr-1">mdi-account</v-icon>
                  Cliente / Sucursal
                </div>
                <v-autocomplete
                  v-model="selectedClientVoucher"
                  :items="clientsVouchers"
                  item-text="name"
                  item-value="id"
                  label="Cliente"
                  return-object
                  dense
                  outlined
                  :disabled="!tipVoucher.value"
                  hide-details="auto"
                  prepend-inner-icon="mdi-account-circle"
                  :loading="isLoading"
                  clearable
                  class="mb-3"
                ></v-autocomplete>

                <v-autocomplete
                  v-model="selectedBranchVoucher"
                  :items="branchOptions"
                  item-text="name"
                  item-value="id"
                  label="Sucursal"
                  dense
                  return-object
                  clearable
                  outlined
                  hide-details="auto"
                  prepend-inner-icon="mdi-office-building"
                  :disabled="!selectedClientVoucher"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined>
        <v-data-table
          :headers="headersVouchers"
          :items="filter_invoices_vouchers"
          :search="searchVouchers"
          :items-per-page="3500"
          v-model="selectedVouchers"
          :loading="loadingVouchers"
          item-key="invoice_id"
          show-select
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                {{ tipVoucher.text }}
                {{ selectedCurrency.description }}
              </v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              {{ filter_invoices_vouchers.length }}
              <v-divider class="mx-4" inset vertical></v-divider>
            <span class="font-weight-bold text-body-1">
              {{ currencyFormat(  filter_invoices_vouchers.reduce((sum, invoice) => sum + parseFloat(invoice.total_amount || 0), 0)) }} {{ selectedCurrency.description }}

            </span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchVouchers"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line outlined
                hide-details dense
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.total_amount`]="{ item }">
            {{ currencyFormat(item.total_amount) }} {{ item.currency_code }}
          </template>

          <template v-slot:[`item.responsable_entity_name`]="{ item }">
          <span>
            {{ item.entity_name }} 
          </span>
          <br>
          <span>
            {{ item.entity_branch_name }}
          </span>
          <br>
          <span>
            {{ item.responsable_entity_name }}
          </span>
     
          </template>
          
          <template v-slot:[`item.created_date`]="{ item }">
            {{ item.created_date }}
          </template>
        </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import GeneralGhCalendar from "@/components/GeneralGhCalendar.vue";
export default {
  name: "VoucherDialog",
  props: {
    value: Boolean,
    currencies: Array,
    seleted_currencies: Number,
    itemsVouchers: Array,
    loadingVouchers: Boolean,
    filters: Object,
  },
  data() {
    return {
      menuVouchers: false,
      dateSearchVouchers: null,
      start_date: null,
      range: "",
      selected_currency_id: null,
      tipVoucher: { text: "SELECCIONA UN TIPO", value: 0 },
      selectedClientVoucher: null,
      selectedBranchVoucher: null,
      searchVouchers: "",
      selectedVouchers: [],
      isLoading: false,
      search: null,
      headersVouchers: [
        { text: "Factura", value: "invoice_number" },
        { text: "Sucursal", value: "location_description" },
        { text: "Cliente", value: "responsable_entity_name" },
        { text: "Fecha", value: "emission_date" },
        { text: "Total", value: "total_amount", align: "end" },
      ],
      voucherTypes: [
        { text: "SELECCIONA UN TIPO", value: 0 },
        { text: "VOUCHERS", value: 5 },
        { text: "BONOS", value: 8 },
      ],
      manual_currency_rate: null,
    };
  },
  components: {
    GeneralGhCalendar,
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    // dateFormatDMY() {
    //   return moment(this.dateSearchVouchers).format("DD/MM/YYYY");
    // },
    filter_invoices_vouchers() {
  // Si no hay cliente seleccionado, devuelve todos los vouchers
  if (
    !this.selectedClientVoucher || 
    this.selectedClientVoucher.id === -1 || 
    this.itemsVouchers.length === 0
  ) {
    return this.itemsVouchers;
  }

  // Aplica el filtro considerando selectedClientVoucher y, si aplica, selectedBranchVoucher
  return this.itemsVouchers.filter((invoice) => {
    const matchesClient = invoice.entity_id === this.selectedClientVoucher.id;

    // Verifica si se debe aplicar el filtro de sucursal o ignorarlo
    const matchesBranch = !this.selectedBranchVoucher || 
                          this.selectedBranchVoucher.id === -1 ||
                          invoice.entity_branch_id === this.selectedBranchVoucher.id;

    return matchesClient && matchesBranch;
  });
},

    clientsVouchers() {
      const uniqueClients = this.itemsVouchers.reduce((acc, invoice) => {
        if (!acc.some((client) => client.id == invoice.entity_id)) {
          acc.push({
            name: invoice.entity_name,
            id: invoice.entity_id,
          });
        }
        return acc;
      }, []);
      return [{ name: "Todas", id: -1}, ...uniqueClients];
    },
    branchOptions() {

      if(this.selectedClientVoucher==null)
    {
      return []
    }

    // Filtra los itemsVouchers para obtener solo los de la entidad seleccionada
    const filteredVouchers = this.itemsVouchers.filter(
      (invoice) => invoice.entity_id === this.selectedClientVoucher.id
    );
 
    // Obtiene las sucursales únicas de los items filtrados
    const uniqueBranches = filteredVouchers.reduce((acc, invoice) => {
      if (!acc.some((branch) => branch.id === invoice.entity_branch_id)) {
        acc.push({
          name: invoice.entity_branch_name,
          id: invoice.entity_branch_id,
        });
      }
      return acc;
    }, []);

    // Agrega la opción "Todas" al inicio de la lista y retorna el resultado
    return [{ name: "Todas", id: -1 }, ...uniqueBranches];
  },
    selectedCurrency() {
      return this.currencies.find((c) => c.id === this.selected_currency_id) || {};
    },
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
      this.tipVoucher = { text: "SELECCIONA UN TIPO", value: 0 };
    },
    getFlag(id) {
      return id === 1 ? "do" : id === 2 ? "ht" : id === 3 ? "us" : id === 4 ? "es" : "us";
    },
    onTipVoucherChange(newValue) {
      if (newValue.value !== 0) {
        this.clearInputVouchers();
        this.fetchVouchers();
      }
    },
    clearInputVouchers() {
      this.$emit("clear-input-vouchers");
    },
    loadVouchers() {
      if(this.manual_currency_rate!=null && this.manual_currency_rate<=0){
        this.$toast.error("La tasa de cambio debe ser mayor a 0");
        return;
      }
      this.$emit("load-vouchers", this.selectedVouchers, this.tipVoucher.value,`Facturacion de ${this.selectedVouchers.length} ${this.tipVoucher.text.toLowerCase()} correspondiente a la ${this.range}`,this.manual_currency_rate);
    },
    searchClients(val) {
      this.$emit("search-clients", val);
    },
  
    fetchVouchers() {
      if (this.tipVoucher.value === 0) return;

      const fetchData = {
        business_unit: this.filters.business.id,
        currency_id: this.selected_currency_id,
        entity_id: this.selectedClientVoucher ? this.selectedClientVoucher.id : null,
        branch_id: this.selectedBranchVoucher,
        type: this.tipVoucher.value,
        start_date: this.start_date || null,
        date: this.dateSearchVouchers,
      };

      this.$emit("fetch-vouchers", fetchData);
    },
    get_range(range){
      this.start_date = range.start.date_begin;
      this.dateSearchVouchers = range.start.date_end;
      this.range=range.start.text;
      this.fetchVouchers();
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.selected_currency_id = this.seleted_currencies;
      }
    },
    seleted_currencies(val) {
      if (this.selected_currency_id == null) {
        this.selected_currency_id = val;
      }
    },
    selected_currency_id() {
      if (this.tipVoucher.value !== 0) {
        this.clearInputVouchers();
        this.fetchVouchers();
      }
    },
    // dateSearchVouchers() {
    //   if (this.tipVoucher.value !== 0) {
    //     this.fetchVouchers();
    //   }
    // },
  
  },
};
</script>
